import React, { useState, useEffect, useMemo } from 'react';
import { Button, Modal } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import cn from 'classnames';
import { apiHolder, apis, apiHolder as api, } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
import { ReactComponent as IconClose } from '@/images/icons/mail/icon-close1.svg';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import IconCard from '@web-common/components/UI/IconCard';
import style from './risk.reminder.module.scss';
import { useContactModel } from '@web-common/hooks/useContactModel';
import { getIn18Text } from 'api';
import { PrivilegeCheckForMailPlus } from '@/components/UI/PrivilegeEnhance';
import { refreshContactDataByEmails } from '@web-common/state/reducer/contactReducer';
import { getMainAccount } from '@web-common/components/util/contact';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { scenes } from '@/components/Layout/CustomsData/components/uniDrawer/uniDrawerLeads2';
import { PublicMailDomainList } from '@web-edm/utils/utils';
import { UniDrawerModuleId, showUniDrawer, Module } from '@lxunit/app-l2c-crm';
const systemApi = apiHolder.api.getSystemApi();
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const mailBlacklistApi = apiHolder.api.requireLogicalApi(apis.mailBlacklistApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const productApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
export const RiskReminder = (props) => {
    var _a, _b;
    const { senderMail, senderName, visible, setVisible, _account = getMainAccount(), email, contactId } = props;
    const [noMorePromptVis, setNoMorePromptVis] = useState(false);
    const [addToBLVis, setAddToBLVis] = useState(false);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const contactName = ((_b = (_a = props.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contactName) || email;
    const contact = useContactModel({ email, contactId, _account, name: contactName });
    const [, setUniToCustomerOrClueParam] = useState2RM('uniToCustomerOrClueParam');
    const isCustomer = useMemo(() => !!(contact === null || contact === void 0 ? void 0 : contact.customerOrgModel), [contact]);
    useEffect(() => {
        if (isCustomer) {
            setVisible(false);
        }
    }, [isCustomer]);
    const addToContact = async () => {
        trackApi.track('pcMail_click_add_mailcontacts', {});
        try {
            const res = await (contactApi === null || contactApi === void 0 ? void 0 : contactApi.doInsertContact({
                list: { name: senderName, emailList: [senderMail] },
                _account,
            }));
            if (res === null || res === void 0 ? void 0 : res.success) {
                message.success(getIn18Text('GAILIANXIRENYI'));
                setVisible(false);
            }
            else {
                message.error(getIn18Text('TIANJIASHIBAI'));
            }
        }
        catch (error) {
            message.error(getIn18Text('TIANJIASHIBAI'));
        }
    };
    const handleClose = () => {
        setVisible(false);
    };
    const checkBL = async () => {
        const url = await mailConfApi.getSettingUrlCommon({
            name: 'options.AntiSpamModule',
            inLocal: false,
            urlType: {},
            isCorpMail,
        });
        if (url && url.length > 0) {
            systemApi.openNewWindow(url, true);
        }
        else {
            Toast.warn({
                content: getIn18Text('WUFADAKAIZHI'),
                duration: 3,
            });
        }
    };
    const cont = () => {
        return (React.createElement("span", null,
            getIn18Text('GAILIANXIRENYI11'),
            React.createElement("span", { className: style.checkBL, onClick: checkBL }, getIn18Text('CHAKAN'))));
    };
    const addToBL = async () => {
        setAddToBLVis(false);
        trackApi.track('pcMail_click_join_blacklists', {});
        try {
            const res = await mailBlacklistApi.addBlacklist(senderMail);
            if (res) {
                setVisible(false);
                message.success(cont());
            }
            else {
                message.error(getIn18Text('TIANJIADAOHEIMING'));
            }
        }
        catch (error) {
            console.log(getIn18Text('TIANJIADAOHEIMING'), error);
            message.error(getIn18Text('TIANJIADAOHEIMING'));
        }
    };
    const noMorePrompt = async () => {
        setNoMorePromptVis(false);
        const result = await mailConfApi.updateRiskReminderStatus(false);
        if (result) {
            setVisible(false);
            message.success(getIn18Text('NINDECAOZUOYI'));
        }
        else {
            message.warn(getIn18Text('GUANLIYUANYISHE'));
        }
    };
    const addToExistedCustomer = React.useCallback(() => {
        if (contact) {
            trackApi.track('uni_external_detail_iframe', {
                button: 'E+_read_add_contact',
            });
            trackApi.track('pcMail_click_stranger_mailDetailPage', {
                action: 'existingCustomer',
            });
            const { contact: contactObj } = contact;
            const { contactName, accountName, displayEmail } = contactObj;
            const email = displayEmail || accountName;
            setUniToCustomerOrClueParam({
                visible: true,
                type: 'customer',
                way: scenes.Email_Read,
                contacts: [
                    {
                        email,
                        contact_name: contactName || email,
                    },
                ],
                onOk: () => {
                    refreshContactDataByEmails({
                        [_account]: [email],
                    }, new Map([[email, contactName]]));
                },
            });
        }
    }, [contact]);
    const customerData = useMemo(() => {
        const emailDomain = (email === null || email === void 0 ? void 0 : email.split('@')[1]) || '';
        const webapp = PublicMailDomainList.includes(emailDomain) ? '' : emailDomain;
        return {
            company_name: '',
            website: webapp,
            contact_list: [
                {
                    email: props.email,
                    condition: 'company',
                    contact_name: props.senderName,
                },
            ],
        };
    }, [props.email, props.senderName]);
    const addToCustomer = React.useCallback(() => {
        trackApi.track('uni_external_detail_iframe', {
            button: 'E+_read_create',
        });
        trackApi.track('pcMail_click_stranger_mailDetailPage', {
            action: 'addCustomer',
        });
        showUniDrawer({
            moduleId: UniDrawerModuleId.CustomerDetail,
            moduleProps: {
                visible: true,
                onClose: () => { },
                onSuccess: () => {
                    setVisible(false);
                    refreshContactDataByEmails({
                        [_account]: [email || senderMail],
                    }, new Map([[email || senderMail, senderName]]));
                },
                customerData,
                source: 'mailListRead',
                drawerIdentify: {
                    module: Module.Email,
                    opType: 'create',
                },
                minimize: true,
                bodyContainer: document.querySelector('#mailboxModule'),
            },
        });
    }, []);
    const showBtn = useMemo(() => {
        var _a;
        return !isCustomer && ((systemApi.inEdm() && productApi.getABSwitchSync('edm_mail')) || ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion));
    }, [isCustomer]);
    if (!email) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: style.riskReminder, hidden: !visible },
            React.createElement("div", { className: style.btnClose, onClick: handleClose },
                React.createElement(IconClose, null)),
            React.createElement("div", { className: style.intro },
                React.createElement(IconCard, { type: "warnYellow", className: style.warn }),
                React.createElement("span", { className: style.text },
                    getIn18Text('JIANCEDAO'),
                    senderMail,
                    getIn18Text('BUZAINIDETONG'))),
            React.createElement("div", { className: style.funs },
                React.createElement("div", null,
                    React.createElement("span", { className: style.funBtn, onClick: addToContact }, getIn18Text('TIANJIAZHITONGXUN')),
                    showBtn ? (React.createElement(React.Fragment, null,
                        React.createElement(PrivilegeCheckForMailPlus, { resourceLabel: "CONTACT", accessLabel: "OP" },
                            React.createElement("span", { className: style.funBtn, onClick: addToCustomer }, getIn18Text('addCustomer'))),
                        React.createElement(PrivilegeCheckForMailPlus, { resourceLabel: "CONTACT", accessLabel: "OP" },
                            React.createElement("span", { className: style.funBtn, onClick: addToExistedCustomer }, getIn18Text('TIANJIADAOYIYOUKEHU'))))) : null,
                    React.createElement("span", { className: style.funBtn, onClick: () => setAddToBLVis(true) }, getIn18Text('JIARUHEIMINGDAN'))),
                React.createElement("div", null,
                    React.createElement("span", { className: cn(style.funBtn, style.funBtnNoWarn), onClick: () => setNoMorePromptVis(true) }, getIn18Text('BUZAITIXING'))))),
        React.createElement(Modal, { visible: addToBLVis, footer: null, closable: false, closeIcon: false, wrapClassName: style.reminderModal, centered: true, destroyOnClose: true },
            React.createElement("div", null,
                React.createElement("div", { className: style.title },
                    React.createElement(IconCard, { type: "downloadFail", className: style.warn }),
                    getIn18Text('QUERENJIAHEIMING')),
                React.createElement("div", { className: style.intro },
                    getIn18Text('QUEDINGJIANGXIAOMING'),
                    senderMail,
                    getIn18Text('JIARUHEIMINGDAN11')),
                React.createElement("div", { className: style.footer },
                    React.createElement(Button, { onClick: () => setAddToBLVis(false) }, getIn18Text('QUXIAO')),
                    React.createElement(Button, { type: "primary", style: { marginLeft: 16 }, onClick: addToBL }, getIn18Text('QUEDING'))))),
        React.createElement(Modal, { visible: noMorePromptVis, footer: null, closable: false, closeIcon: false, wrapClassName: style.reminderModal, centered: true, destroyOnClose: true },
            React.createElement("div", null,
                React.createElement("div", { className: style.title },
                    React.createElement(IconCard, { type: "downloadFail", className: style.warn }),
                    getIn18Text('QUERENBUZAITI')),
                React.createElement("div", { className: style.intro }, getIn18Text('XIACIJINRUBU')),
                React.createElement("div", { className: style.footer },
                    React.createElement(Button, { onClick: () => setNoMorePromptVis(false) }, getIn18Text('QUXIAO')),
                    React.createElement(Button, { type: "primary", style: { marginLeft: 16 }, onClick: noMorePrompt }, getIn18Text('QUEDING')))))));
};
